module.exports = __webpack_public_path__ + "img/seal_of_beetletun.4397d417.png";